import { VWOAnalyticsService, VWOEvents } from '@grupoboticario/barril-del-chavo'
import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  styled,
} from '@grupoboticario/flora-react'
import ImportContactsIcon from '@mui/icons-material/ImportContacts'
import { PropsWithChildren, useEffect, useState } from 'react'
import { CatalogAccordionEvents } from './CatalogAccordionEvents'
import { CatalogAccordionTitle } from './CatalogAccordionTitle'

const StyledImportContactsIcon = styled(ImportContactsIcon, {
  fill: '$actionSuccessHighlight !important',
  marginRight: '$2',
})

const CATALOG_ACCORDION_ITEM = 'catalog-accordion-item'
export const CatalogAccordion = ({ children }: PropsWithChildren<{}>) => {
  const [accordionValue, setAccordionValue] = useState<string | undefined>()
  const [opened, setAccordionOpened] = useState<boolean>(false)

  const toggleAccordion = () => setAccordionOpened((prev) => !prev)

  const handleOpenAccordion = () => {
    setAccordionValue((prev) =>
      prev === CATALOG_ACCORDION_ITEM ? undefined : CATALOG_ACCORDION_ITEM,
    )
    toggleAccordion()
  }

  useEffect(() => {
    window.addEventListener(CatalogAccordionEvents.OPEN_ACCORDION, handleOpenAccordion)

    return () =>
      window.removeEventListener(CatalogAccordionEvents.OPEN_ACCORDION, handleOpenAccordion)
  }, [])

  const handleAccordionButtonClick = () => {
    const isClosing = opened

    VWOAnalyticsService.dispatchVWOEvent(VWOEvents.INTERACTION_WITH_CATALOG, {
      actiontype: isClosing ? 'click:esconder-catalogo' : 'click:ver-catalogo',
    })

    toggleAccordion()
  }

  return (
    <Accordion
      collapsible
      type="single"
      defaultValue={accordionValue}
    >
      <AccordionItem
        value={CATALOG_ACCORDION_ITEM}
        css={{ padding: '$4 0', margin: '$4' }}
      >
        <AccordionButton
          css={{
            padding: '$4',
            border: '2px solid $backgroundSecondary !important',
            borderRadius: '$medium',
            '[data-level="1"]': {
              border: 'none',
            },
          }}
          onMouseDown={handleAccordionButtonClick}
        >
          <StyledImportContactsIcon
            sx={{
              fontSize: '1.4rem',
            }}
          />
          <CatalogAccordionTitle isOpened={opened} />
        </AccordionButton>
        <AccordionPanel
          css={{
            ['[data-panel-content]']: { paddingRight: 0, marginLeft: '-$4', marginRight: '-$4' },
          }}
        >
          <Box css={{ marginTop: '$6' }}>{children}</Box>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  )
}
